export const firstNames = [
  ['Emma', 'Noah'],
  ['Olivia', 'Liam'],
  ['Ava', 'William'],
  ['Sophia', 'Mason'],
  ['Isabella', 'James'],
  ['Mia', 'Benjamin'],
  ['Charlotte', 'Jacob'],
  ['Abigail', 'Michael'],
  ['Emily', 'Elijah'],
  ['Harper', 'Ethan'],
  ['Amelia', 'Alexander'],
  ['Evelyn', 'Oliver'],
  ['Elizabeth', 'Daniel'],
  ['Sofia', 'Lucas'],
  ['Samantha', 'Caleb'],
  ['Stella', 'Hunter'],
  ['Paisley', 'Christian'],
  ['Violet', 'Isaiah'],
  ['Mila', 'Thomas'],
  ['Allison', 'Aaron'],
  ['Alexa', 'Lincoln'],
  ['Anna', 'Charles'],
  ['Hazel', 'Eli'],
  ['Aaliyah', 'Landon'],
  ['Ariana', 'Connor'],
  ['Lucy', 'Josiah'],
  ['Caroline', 'Jonathan'],
  ['Sarah', 'Cameron'],
  ['Genesis', 'Jeremiah'],
  ['Kennedy', 'Mateo'],
  ['Sadie', 'Adrian'],
  ['Gabriella', 'Hudson'],
  ['Madelyn', 'Robert'],
  ['Luna', 'Jose'],
  ['Bella', 'Ian'],
  ['Quinn', 'Cooper'],
  ['Lydia', 'Gavin'],
  ['Peyton', 'Carson'],
  ['Melanie', 'Jaxson'],
  ['Kylie', 'Theodore'],
  ['Aubree', 'Jason'],
  ['Mackenzie', 'Ezra'],
  ['Kinsley', 'Chase'],
  ['Cora', 'Parker'],
  ['Julia', 'Xavier'],
  ['Taylor', 'Kevin'],
  ['Katherine', 'Zachary'],
  ['Madeline', 'Tyler'],
  ['Gianna', 'Ayden'],
  ['Eliana', 'Elias'],
  ['Elena', 'Bryson'],
  ['Vivian', 'Leonardo'],
  ['Willow', 'Greyson'],
  ['Reagan', 'Sawyer'],
  ['Brianna', 'Roman'],
  ['Clara', 'Brandon'],
  ['Faith', 'Bentley'],
  ['Ashley', 'Kayden'],
  ['Emilia', 'Ryder'],
  ['Isabelle', 'Nathaniel'],
  ['Annabelle', 'Vincent'],
  ['Rylee', 'Miles'],
  ['Valentina', 'Santiago'],
  ['Everly', 'Harrison'],
  ['Hadley', 'Tristan'],
  ['Sophie', 'Declan'],
  ['Alexandra', 'Cole'],
  ['Natalia', 'Maxwell'],
  ['Ivy', 'Luis'],
  ['Maria', 'Justin'],
  ['Josephine', 'Everett'],
  ['Delilah', 'Micah'],
  ['Bailey', 'Axel'],
  ['Jade', 'Wesley'],
  ['Ximena', 'Max'],
  ['Alexis', 'Silas'],
  ['Alyssa', 'Weston'],
  ['Brielle', 'Ezekiel'],
  ['Jasmine', 'Juan'],
  ['Liliana', 'Damian'],
  ['Adalynn', 'Camden'],
  ['Morgan', 'Ashton'],
  ['Lauren', 'Jesus'],
  ['Sydney', 'Brody'],
  ['Nova', 'Emmett'],
  ['Trinity', 'Abel'],
  ['Lyla', 'Jayce'],
  ['Margaret', 'Maverick'],
  ['Ariel', 'Bennett'],
  ['Adalyn', 'Giovanni'],
  ['Athena', 'Eric'],
  ['Lilly', 'Maddox'],
  ['Melody', 'Kaiden'],
  ['Isabel', 'Kai'],
  ['Jordyn', 'Bryce'],
  ['Jocelyn', 'Alex'],
  ['Eden', 'Calvin'],
  ['Paige', 'Ryker'],
  ['Teagan', 'Jonah'],
  ['Valeria', 'Luca'],
  ['Sara', 'King'],
  ['Norah', 'Timothy'],
  ['Rose', 'Alan'],
  ['Aliyah', 'Brantley'],
  ['Mckenzie', 'Malachi'],
  ['Molly', 'Emmanuel'],
  ['Raelynn', 'Abraham'],
  ['Leilani', 'Antonio'],
  ['Valerie', 'Richard'],
  ['Mariah', 'Steven'],
  ['Mya', 'Matteo'],
  ['Arya', 'Hayden'],
  ['Ryleigh', 'Patrick'],
  ['Adaline', 'Grant'],
  ['Brooke', 'Preston'],
  ['Rachel', 'Tucker'],
  ['Eliza', 'Jesse'],
  ['Angelina', 'Finn'],
  ['Amy', 'Oscar'],
  ['Reese', 'Kaleb'],
  ['Alina', 'Gael'],
  ['Cecilia', 'Graham'],
  ['Londyn', 'Elliot'],
  ['Gracie', 'Alejandro'],
  ['Payton', 'Rowan'],
  ['Esther', 'Marcus'],
  ['Alaina', 'Jeremy'],
  ['Charlie', 'Zayden'],
  ['Eloise', 'Jasper'],
  ['Lila', 'Lorenzo'],
  ['Fiona', 'Zane'],
  ['Callie', 'Zion'],
  ['Lucia', 'Beckett'],
  ['Angela', 'River'],
  ['Marley', 'Jax'],
  ['Adriana', 'Andres'],
  ['Parker', 'Dawson'],
  ['Alexandria', 'Messiah'],
  ['Giselle', 'Jaden'],
  ['Alivia', 'Rhett'],
  ['Elaina', 'Clayton'],
  ['Sloane', 'Thiago'],
  ['June', 'Spencer'],
  ['Diana', 'Amari'],
  ['Blakely', 'Josue'],
  ['Aniyah', 'Holden'],
  ['Olive', 'Emilio'],
  ['Jennifer', 'Arthur'],
  ['Paris', 'Chance'],
  ['Miranda', 'Eduardo'],
  ['Lena', 'Leon'],
  ['Jacqueline', 'Travis'],
  ['Paislee', 'Ricardo'],
  ['Jane', 'Damien'],
  ['Raegan', 'Manuel'],
  ['Lyric', 'Gage'],
  ['Lilliana', 'Keegan'],
  ['Adelynn', 'Titus'],
  ['Lucille', 'Raymond'],
  ['Selena', 'Kyrie'],
  ['River', 'Nash'],
  ['Annie', 'Finley'],
  ['Cassidy', 'Fernando'],
  ['Jordan', 'Louis'],
  ['Thea', 'Peyton'],
  ['Mariana', 'Rafael']
]

export const lastNames = ['Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Miller', 'Davis', 'Rodriguez', 'Martinez', 'Hernandez', 'Lopez', 'Gonzales', 'Wilson', 'Anderson', 'Thomas', 'Taylor', 'Moore', 'Jackson', 'Martin', 'Lee', 'Perez', 'Thompson', 'White', 'Harris', 'Sanchez', 'Clark', 'Ramirez', 'Lewis', 'Robinson', 'Walker', 'Young', 'Allen', 'King', 'Wright', 'Scott', 'Torres', 'Nguyen', 'Hill', 'Flores', 'Green', 'Adams', 'Nelson', 'Baker', 'Hall', 'Rivera', 'Campbell', 'Mitchell', 'Carter', 'Roberts', 'Gomez', 'Phillips', 'Evans', 'Turner', 'Diaz', 'Parker', 'Cruz', 'Edwards', 'Collins', 'Reyes', 'Stewart', 'Morris', 'Morales', 'Murphy', 'Cook', 'Rogers', 'Gutierrez', 'Ortiz', 'Morgan', 'Cooper', 'Peterson', 'Bailey', 'Reed', 'Kelly', 'Howard', 'Ramos', 'Kim', 'Cox', 'Ward', 'Richardson', 'Watson', 'Brooks', 'Chavez', 'Wood', 'James', 'Bennet', 'Gray', 'Mendoza', 'Ruiz', 'Hughes', 'Price', 'Alvarez', 'Castillo', 'Sanders', 'Patel', 'Myers', 'Long', 'Ross', 'Foster']

export const religions = [
  { value: 'Christianity', probability: 2168.0 / 2 },
  { value: 'Islam', probability: 1599.0 / 2 },
  { value: 'Atheist', probability: 1193.0 / 2 },
  { value: 'Hinduism', probability: 1161.0 / 2 },
  { value: 'Buddhism', probability: 506.0 / 2 },
  { value: 'Spiritism', probability: 15.0 },
  { value: 'Judaism', probability: 14.7 },
  { value: 'Baháʼí', probability: 5.0 },
  { value: 'Jainism', probability: 4.2 },
  { value: 'Shinto', probability: 4.0 },
  { value: 'Cao Dai', probability: 4.0 },
  { value: 'Zoroastrianism', probability: 2.6 },
  { value: 'Tenrikyo', probability: 2.0 },
  { value: 'Animism', probability: 1.9 },
  { value: 'Neo-Paganism', probability: 1.0 },
  { value: 'Unitarian Universalism', probability: 0.8 },
  { value: 'Rastafari', probability: 0.6 }
]

export const genders = [
  { value: 'Male', probability: 20 },
  { value: 'Female', probability: 20 },
  { value: 'Agender', probability: 2 },
  { value: 'Transgender', probability: 2 },
  { value: 'Fluid', probability: 2 },
  { value: 'Non binary', probability: 2 }
]

export const sexualities = [
  { value: 'Heterosexual', probability: 300 },
  { value: 'Homosexual', probability: 100 },
  { value: 'Bisexual', probability: 15 },
  { value: 'Pansexual', probability: 9 },
  { value: 'Bicurious', probability: 9 },
  { value: 'Polysexual', probability: 0.5 },
  { value: 'Monosexual', probability: 0.5 },
  { value: 'Allosexual', probability: 0.5 },
  { value: 'Questioning', probability: 0.5 },
  { value: 'Asexual', probability: 8 },
  { value: 'Demisexual', probability: 1 },
  { value: 'Heteronormative', probability: 0.5 },
  { value: 'Erasure', probability: 0.5 },
  { value: 'Cishet', probability: 0.5 },
  { value: 'Queer', probability: 2 },
  { value: 'Ally', probability: 0.5 }
]

export const races = [
  { value: 'White', probability: 60 },
  { value: 'Hispanic', probability: 20 },
  { value: 'Black', probability: 15 },
  { value: 'Asian', probability: 6 },
  { value: 'Mestizo', probability: 3 },
  { value: 'Native American', probability: 2 }
]
